<script lang="ts" setup>
import { computed } from 'vue'
import { Link } from '@brighterly/lib-lumee-ui'

import type { LessonRoomChatMessage } from '@stores/lesson-room/interfaces'

import qaConfig from '@config/qa.json'
import { linkify } from '@utils/helpers/linkify'

defineOptions({
  name: 'LessonRoomChatMessage',
})

const props = defineProps<{
  message: LessonRoomChatMessage
}>()

const displayName = computed<string>(() => props.message.isLocal ? 'You' : props.message.name)
</script>

<template>
  <div :class="['lesson-room-chat-message', { 'lesson-room-chat-message--own': message.isLocal }]">
    <div class="lesson-room-chat-message__header">
      <span class="lesson-room-chat-message__name btly-text-title-s">{{ displayName }}</span>
      <span class="lesson-room-chat-message__time btly-text-body-m">{{ message.time }}</span>
    </div>
    <div
      class="lesson-room-chat-message__content btly-text-body-xl"
      :data-qa="qaConfig.attributes.contentChat"
    >
      <template
        v-for="(seg, i) in linkify(message.content)"
        :key="i"
      >
        <Link
          v-if="seg.type === 'link'"
          :href="seg.href"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          size="lg"
        >
          {{ seg.value }}
        </Link><template v-else>
          {{ seg.value }}
        </template>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/LessonRoom/LessonRoomChatMessage.scss" />
